import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'catalogos/directorio-de-areas';

/**
 * GET all directorios de area
 * @returns {Promise<object[]>}
 */
export const getAllAreas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Area by ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getAreaByID = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Area
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const createArea = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Area
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const updateArea = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Area
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteArea = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Area
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarArea = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Costo de nómina de un Área (pestaña Costo): claves del Presupuesto Anual de Nómina del Área
 * con lo pagado de enero a diciembre en las nóminas autorizadas.
 * @param {object} params { directorio_area, periodo_fiscal }
 * @returns {Promise<object|null>} { periodo_fiscal, anio, claves }
 */
export const getCostoDeArea = async (params) => {
  try {
    const response = await API.get('catalogos/directorio-de-area-costo', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
